import { FormDialog } from 'components/dialog/form'
import { SearchsConventionResult, usePostSearchsConvention } from 'interface/search/convention'
import { useSearchsConventionForm, SearchsConventionForm } from '../form'

type AddSearchsConventionDialogProps = {
  searchId: number
  onSubmit: (result: SearchsConventionResult) => void
  onClose: () => void
}
export const AddSearchsConventionDialog = ({
  searchId,
  onSubmit,
  onClose
}: AddSearchsConventionDialogProps) => {
  const [postState, submit] = usePostSearchsConvention(searchId, { onPosted: onSubmit })
  const form = useSearchsConventionForm({ searchId, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="分析対象のガイドラインを登録"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsConventionForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
